import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Grid, TextField } from '@mui/material';
import { Color } from '../../../assets/color';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import * as AuthActions from "../../../redux/actions/authAction";

const ChangePassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { superadminAdminPartnerDetails } = useSelector((state) => state.authReducer);

    const [inputFieldDetail, setInputFieldDetail] = useState({ password: '', confirm_password: '' });
    const [inputFieldError, setInputFieldError] = useState({ password: '', confirm_password: '' });

    const handleInputFieldDetailError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value })); //* Handle Input Field : Error
    const handleInputFieldDetail = (event) => setInputFieldDetail({ ...inputFieldDetail, [event.target.name]: event.target.value }); //* Handle Input Field : Data


    //! Handle Validation
    const handleValidation = () => {
        let isValid = true;
        const { password, confirm_password } = inputFieldDetail;

        if (!password) {
            handleInputFieldDetailError("password", "Please Enter Password.")
            isValid = false;
        }
        if (password != confirm_password) {
            handleInputFieldDetailError("confirm_password", "Please Enter Same Password.")
            isValid = false;
        }
        return isValid;
    };

    //! Handle Submit
    const handleSubmit = async () => {
        if (handleValidation()) {
            console.log("Detail :: ", { ...inputFieldDetail })

            const { password, confirm_password } = inputFieldDetail;
            const payload = {
                data: { password, confirm_password },
                onComplete: () => setInputFieldDetail({ password: '', confirm_password: '' })
            }

            //! Dispatching API for Changing Password
            dispatch(AuthActions.changePassword(payload))
        }
    };

    return (
        <>
            <RouteHeader title={`Change Password`} sub_title={`Update your ${superadminAdminPartnerDetails?.role?.toLowerCase()} password to maintain account security`} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <DatatableHeading title={`Change ${superadminAdminPartnerDetails?.role} Password`} sub_title={'Update your password to maintain account security'} />
                </div>

                <Grid container spacing={3} sx={{ marginTop: '20px' }}>
                    {true && <>
                        <Grid item lg={6} sm={12} md={12} xs={12}>
                            <TextField label="New Password" variant="outlined" fullWidth
                                name="password"
                                value={inputFieldDetail?.password}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.password ? true : false}
                                helperText={inputFieldError.password}
                                onFocus={() => handleInputFieldDetailError("password", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item lg={6} sm={12} md={12} xs={12}>
                            <TextField label="Confirm New Password" variant="outlined" fullWidth
                                name="confirm_password"
                                value={inputFieldDetail?.confirm_password}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.confirm_password ? true : false}
                                helperText={inputFieldError.confirm_password}
                                onFocus={() => handleInputFieldDetailError("confirm_password", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2} justifyContent="flex-start">
                                <Grid item>
                                    <div onClick={handleSubmit} style={{  padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: Color.white, fontSize: '14px', cursor: 'pointer' }}>Submit</div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>}
                </Grid>
            </div>
        </>
    )
}

export default ChangePassword;